import * as moment from 'moment';

import { Component } from '@angular/core';
import { Observable } from 'rxjs/Rx';
import { Subscription }   from 'rxjs/Subscription'
import { Router, NavigationStart, NavigationEnd } from '@angular/router';
import { HolidayService } from '../services/HolidayService';
// Service
import { BookingHolidayService } from '../services';
import { User } from '../../common/modules/user/models/User';
import { SessionStorageService } from '../../common/modules/core/services';
import { SessionService } from '../../common/modules/user/services/SessionService';
import { UserService } from '../../common/modules/user/services/UserService'
import '../../styles.sass';
import * as _ from 'lodash';

@Component({
	selector: 	'my-app',
	template: 	require('./AppComponent.html'),
	styles: [require('./AppComponent.sass')]
})

export class AppComponent {
	private module: string;
	private hostName: string;
    userData: User;
    message:        string;
    messageType:    string;
	private subscribtion: Subscription;
	private countDownSubscribe: Subscription;
	// For Countdown
	private showCountdown: boolean = false;
	private currentCountdown: string = '';
	private _diff: number;
	private isTimedOut: boolean = false;
    private parent: any;
    private children: any[];
	private currentRoute: string;
	protected devEnv: any = ['camp.eca.dev.nascorp.vn', 'asa.eca.dev.nascorp.vn', 'holiday.eca.dev.nascorp.vn', 'bus.eca.dev.nascorp.vn'];
    protected testEnv: any = ['camp.eca.test.nascorp.vn', 'asa.eca.test.nascorp.vn', 'holiday.eca.test.nascorp.vn', 'bus.eca.test.nascorp.vn'];
    protected stagingEnv: any = ['auth.eca.uat.nascorp.vn','services.eca.uat.nascorp.vn','asa.eca.uat.nascorp.vn','holidayschool.eca.uat.nascorp.vn','bus.eca.uat.nascorp.vn','outdooreducation.eca.uat.nascorp.vn','reen.eca.uat.nascorp.vn','acs.eca.uat.nascorp.vn','pcbs.eca.uat.nascorp.vn'];
    protected procEnv: any = ['outdooreducation.aisvietnam.com', 'asa.aisvietnam.com', 'holidayschool.aisvietnam.com', 'bus.aisvietnam.com']
	
	constructor(
		private service: BookingHolidayService,
		private router: Router,
		private userService: UserService,
		private sessionService: SessionService,
		private sessionStorageService: SessionStorageService,
        private holidayService: HolidayService,
        protected services: BookingHolidayService,
	) {
		this.module = 'holiday';

		let allowCountdownRoute = ['/booking/activites-list', '/booking/excursions', '/booking/bus', '/booking/payment'];

		this.router.events.subscribe((val) => {
			// On end route change
			if(val instanceof NavigationEnd){
				// IF not on allowed route
				if(allowCountdownRoute.indexOf(val.url) === -1){
					this.sessionStorageService.removeData('countdown');
					// Unsubscript
					if(this.subscribtion instanceof Subscription){
						this.subscribtion.unsubscribe();
					}
					if(this.countDownSubscribe instanceof Subscription){
						this.countDownSubscribe.unsubscribe();
					}
					this.showCountdown = false;
					// Re-setup subscription
					this.setupSubscript();
					this.sessionStorageService.setData('currentRoute', val.url);
				}
				else{
					if(val.url == this.currentRoute){
						this.service.startCountdown(true);
					}
					else{
						this.sessionStorageService.setData('currentRoute', val.url);
						this.currentRoute = val.url;						
					}	
				}				
			}

			this.currentRoute = this.sessionStorageService.getData('currentRoute').toString();
		});

		this.setupSubscript();
	}

	ngOnInit() {
		this.getSession();
		this.hostName = window.location.hostname;
    }



    // Get all children of logged parent
    getChildren() {
        this.services.getChildren().subscribe(
            result => {
                this.parent = result.type;
                // Get all children
                if(result.holStudents){
					this.children = _.filter(result.holStudents, {'status': 'active'});
				}

                // Set session children to avoid re-request
                this.setHolidayChildren(result);
            },
            error => {

            }
        )
    }

	redirectLogin() {
		// Redirect to desired URL                    
		if(this.devEnv.indexOf(this.hostName) !== -1){
			return window.location.href = 'http://services.eca.dev.nascorp.vn';
		}
		else if(this.testEnv.indexOf(this.hostName) !== -1){
			return window.location.href = 'http://services.eca.test.nascorp.vn';
		}
		else if(this.stagingEnv.indexOf(this.hostName) !== -1){
			return window.location.href = 'http://services.eca.uat.nascorp.vn';
		}
		else if(this.procEnv.indexOf(this.hostName) !== -1){
			return window.location.href = 'https://services.aisvietnam.com';
		}
		else{
			return window.location.href = 'http://services.local.eca.dev.nascorp.vn';
		}
	}
    // Set holiday children to session
    protected setHolidayChildren(children: any) {
		this.sessionStorageService.setData('holChildren', children);
		// check is ias parent hide profile on menu
		if(children.type == 'ais'){
			this.sessionStorageService.setData('isAisParent', true);
		}
		else {
			this.sessionStorageService.setData('isAisParent', false);
		}
    }
    
	protected getHolidayChildren() {
        return this.sessionStorageService.getData('holChildren');
    }

    private convertParent() {
        this.holidayService.convertParent()
            .subscribe(
                (complete: any) => {
					this.getSession();
					this.getParent();
                },
                (error: any) => {
                }
            );
    }  
	
	private getSession() {
        this.sessionService.getSession()
            .subscribe(
                user => {
                    this.userService.setUserSessionData(user);
                    this.userService.userDataChanged(user);
					this.userData = this.userService.getUserSessionData();

                },
                error => {
                    //TO DO: Handle any error if needed in the furture
                    this.message     = "";
                    this.messageType = "alert";
					this.redirectLogin();
                }
            );
    } 

    private getParent() {
        this.holidayService.getParent()
            .subscribe(
                (parent:any) => {
                    this.parent = parent;

                    if(this.parent.status === "fill-info") {
                        this.router.navigate(['/profile/add-parent'])
                    }
                    else if(this.parent.status == "full") {
                        this.router.navigate(['/booking/students'])
                    }
                    else {
                        this.router.navigate(['/add-student'])
                       
                    }
                },
                (error:any) => {
                    //TO DO: Handle any error if needed in the furture
                    this.message     = "";
                    this.messageType = "alert";
                }
            );
    }
	
	setupSubscript(){
		// Subscribe to service start countdown
		this.subscribtion = this.service.countdownAnnounced$.subscribe(
			start => {
				if(start){
					// Set time
					if(this.getCurrentCountdown()){
						this._diff = +this.getCurrentCountdown();
					}
					else{
						this._diff = 600000;						
					}

					// Show countdown
					this.showCountdown = true;

					this.countDownSubscribe = Observable.interval(1000).map((x) => {
							this._diff = this._diff - 1000;
						}).subscribe((x) => {
							// If end countdown
							if(!this._diff){
								this.sessionTimedOut();
							}
							// Get current countdown
							this.currentCountdown = moment(this._diff).format('mm:ss');
							// Save current countdown
							this.setCurrentCountdown(this._diff);
						});
				}
				else{
					
				}
			}
		);
	}

	// Timeout session handler
	sessionTimedOut() {
		this.isTimedOut = true;
		this.sessionStorageService.removeData('countdown');
		// Stop countdown & unsubscribe
		this.countDownSubscribe.unsubscribe();
		this.showCountdown = false;
		// Navigate to student list on timed out
		// this.router.navigate(['booking/students']);
	}

	// Set countdown to storage
	setCurrentCountdown(countdown: number) {
		this.sessionStorageService.setData('countdown', countdown);
	}
	// Get countdown from storage
	getCurrentCountdown() {
		return this.sessionStorageService.getData('countdown');
	}
}


// WEBPACK FOOTER //
// ./src/holiday/parent/AppComponent.ts